import { Money } from '../product/Money';

export enum DiscountCodeState {
  APPLICATION_STOPPED_BY_PREVIOUS_DISCOUNT = 'ApplicationStoppedByPreviousDiscount',
  DOES_NOT_MATCH_CART = 'DoesNotMatchCart',
  MATCHES_CART = 'MatchesCart',
  MAX_APPLICATION_REACHED = 'MaxApplicationReached',
  NOT_ACTIVE = 'NotActive',
  NOT_VALID = 'NotValid',
}

export enum DiscountErrorCode {
  DISCOUNT_CODE_NON_APPLICABLE = 'DiscountCodeNonApplicable',
  TIME_RANGE_NON_APPLICABLE = 'TimeRangeNonApplicable',
  MAX_APPLICATION_REACHED = 'MaxApplicationReached',
  DOES_NOT_MATCH_CART = 'DoesNotMatchCart',
  DOES_NOT_EXIST = 'DoesNotExist',
  DOES_NOT_VALIDATE = 'DoesNotValidate',
}

export interface Discount {
  discountId?: string;
  code?: string;
  cartDiscountId?: string;
  type?: string;
  value?: Money[];
  state?: DiscountCodeState;
  name?: string;
  description?: string;

  /**
   * Amount discounted.
   *
   * On Cart, the amount discounted in the cart.
   * On LineItem, the amount discounted per single line item.
   */
  discountedAmount?: Money;
}

export interface DiscountedPricePerCount {
  count?: number;
  discounts?: Discount[];
}

export type GeoDiscount = {
  discountCode: string;
  discountPercentage: number;
  source?: 'country' | 'partner' | 'product';
  productKind?: 'course' | 'program';
};
